import styled, { css } from 'styled-components';

export const gaugeStyles = css`
	align-items: center;
	display: flex;
	flex-direction: column;
	text-align: center;
`;
export const Gauge = styled.div`
	${gaugeStyles}
	svg {
		.gauge-arrow {
			fill: #6a6a85;
			transform-origin: 50% 100%;
			transition: all 0.1s ease-out;
		}
	}
`;
export const GaugeLabel = styled.div`
	${gaugeStyles}
	color: #8b8ba7;
	font-size: 1.3rem;
	font-weight: 700;
	line-height: 1.3rem;
	margin-top: 1rem;
`;
export const GaugeMetric = styled.div`
	${gaugeStyles}
	font-feature-settings: 'zero', 'tnum' 1;
	font-size: 2rem;
	font-weight: 900;
	margin-top: 0.6rem;
`;
export const GaugeUnits = styled.div`
	${gaugeStyles}
	color: #8b8ba7;
	font-weight: 300;
	line-height: 1.3rem;
`;
